"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
exports.IS_EQUAL_TO = 'IS_EQUAL_TO';
exports.IS_NOT_EQUAL_TO = 'IS_NOT_EQUAL_TO';
exports.IS_GREATER_THAN = 'IS_GREATER_THAN';
exports.IS_LESS_THAN = 'IS_LESS_THAN';
exports.IS_GREATER_THAN_EQUAL = 'IS_GREATER_THAN_EQUAL';
exports.IS_LESS_THAN_EQUAL = 'IS_LESS_THAN_EQUAL';
exports.IS_IN = 'IS_IN';
exports.IS_NOT_IN = 'IS_NOT_IN';
exports.default = (resource) => utils_1.createAPICall((instance) => (query, config) => instance.post(`query/${resource}?pagination=1`, query, config));
//# sourceMappingURL=createQuery.js.map